export async function fetchObjectives({ tokenID, refreshToken, endpoint }) {
    const postData = {
      tokenID,
      refreshToken
    };
  
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    };
  
    const response = await fetch(endpoint, requestOptions);
    if (!response.ok) {
      throw new Error("Erro ao buscar objetivos");
    }
  
    const data = await response.json();
    return Object.values(data); // array de objetivos
  }